/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AmountRemaining } from './AmountRemaining';
import {
    AmountRemainingFromJSON,
    AmountRemainingFromJSONTyped,
    AmountRemainingToJSON,
} from './AmountRemaining';
import type { ControlProductType } from './ControlProductType';
import {
    ControlProductTypeFromJSON,
    ControlProductTypeFromJSONTyped,
    ControlProductTypeToJSON,
} from './ControlProductType';
import type { Total } from './Total';
import {
    TotalFromJSON,
    TotalFromJSONTyped,
    TotalToJSON,
} from './Total';

/**
 * 
 * @export
 * @interface ControlPaymentInvoice
 */
export interface ControlPaymentInvoice {
    /**
     * 
     * @type {ControlProductType}
     * @memberof ControlPaymentInvoice
     */
    product_type: ControlProductType;
    /**
     * 
     * @type {AmountRemaining}
     * @memberof ControlPaymentInvoice
     */
    amount_remaining: AmountRemaining;
    /**
     * 
     * @type {string}
     * @memberof ControlPaymentInvoice
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPaymentInvoice
     */
    currency_symbol: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPaymentInvoice
     */
    due_date: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPaymentInvoice
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPaymentInvoice
     */
    issue_date: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPaymentInvoice
     */
    payment_link: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPaymentInvoice
     */
    payment_method?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPaymentInvoice
     */
    status: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlPaymentInvoice
     */
    subscribed_to_autopay?: boolean;
    /**
     * 
     * @type {Total}
     * @memberof ControlPaymentInvoice
     */
    total: Total;
    /**
     * 
     * @type {string}
     * @memberof ControlPaymentInvoice
     */
    policy_number?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPaymentInvoice
     */
    opportunity_id?: string;
}

/**
 * Check if a given object implements the ControlPaymentInvoice interface.
 */
export function instanceOfControlPaymentInvoice(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "product_type" in value;
    isInstance = isInstance && "amount_remaining" in value;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "currency_symbol" in value;
    isInstance = isInstance && "due_date" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "issue_date" in value;
    isInstance = isInstance && "payment_link" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function ControlPaymentInvoiceFromJSON(json: any): ControlPaymentInvoice {
    return ControlPaymentInvoiceFromJSONTyped(json, false);
}

export function ControlPaymentInvoiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaymentInvoice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'product_type': ControlProductTypeFromJSON(json['product_type']),
        'amount_remaining': AmountRemainingFromJSON(json['amount_remaining']),
        'currency': json['currency'],
        'currency_symbol': json['currency_symbol'],
        'due_date': json['due_date'],
        'id': json['id'],
        'issue_date': json['issue_date'],
        'payment_link': json['payment_link'],
        'payment_method': !exists(json, 'payment_method') ? undefined : json['payment_method'],
        'status': json['status'],
        'subscribed_to_autopay': !exists(json, 'subscribed_to_autopay') ? undefined : json['subscribed_to_autopay'],
        'total': TotalFromJSON(json['total']),
        'policy_number': !exists(json, 'policy_number') ? undefined : json['policy_number'],
        'opportunity_id': !exists(json, 'opportunity_id') ? undefined : json['opportunity_id'],
    };
}

export function ControlPaymentInvoiceToJSON(value?: ControlPaymentInvoice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product_type': ControlProductTypeToJSON(value.product_type),
        'amount_remaining': AmountRemainingToJSON(value.amount_remaining),
        'currency': value.currency,
        'currency_symbol': value.currency_symbol,
        'due_date': value.due_date,
        'id': value.id,
        'issue_date': value.issue_date,
        'payment_link': value.payment_link,
        'payment_method': value.payment_method,
        'status': value.status,
        'subscribed_to_autopay': value.subscribed_to_autopay,
        'total': TotalToJSON(value.total),
        'policy_number': value.policy_number,
        'opportunity_id': value.opportunity_id,
    };
}

